import React from "react";

import Typography from '@mui/material/Typography';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Categories from './Categories';
import FournisseursClients from './FournisseursClients';
import FournisseursDepots from './FournisseursDepots';
import FournisseursResume from './FournisseursResume';


export default function AdministrationSAVByFoussier() {

    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            <Typography gutterBottom variant="h5">
                Administration du SAV By Foussier
            </Typography>


            <Accordion expanded={expanded === 'fournisseursDepots'} onChange={handleChange('fournisseursDepots')} TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>
                        Fournisseurs / dépôts
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FournisseursDepots />
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'fournisseursClients'} onChange={handleChange('fournisseursClients')} TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>
                        Fournisseurs / clients
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FournisseursClients />
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'categories'} onChange={handleChange('categories')} TransitionProps={{ mountOnEnter: true }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>
                        Catégories
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Categories />
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={expanded === 'FournisseursResume'} onChange={handleChange('FournisseursResume')} TransitionProps={{ mountOnEnter: true }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>
                        Aperçu fournisseurs SAV by Foussier
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FournisseursResume />
                </AccordionDetails>
            </Accordion>           

        </>
    );

}